import { apiClient } from './client';

/**
 * 내가 부르는 이름 (chat-display-names — 2026-08-26).
 *
 * 사람과 방을 같은 창구로 다룬다. 1:1 방 이름을 방에 저장하면 **상대 화면의 이름까지 바뀌므로**
 * (참여자가 둘뿐이라) 이름은 내 쪽에만 붙어야 하고, 그 구조가 사람 별명과 똑같기 때문이다.
 */

export type DisplayNameKind = 'user' | 'room';

export interface DisplayNameEntry {
  kind: DisplayNameKind;
  targetId: string;
  name: string;
}

/** 내가 지어 둔 이름 전부. 많아야 수십 개라 한 번에 받아 두고 쓴다. */
export async function listDisplayNames(): Promise<DisplayNameEntry[]> {
  const { data } = await apiClient.get<{ names: DisplayNameEntry[] }>('/chat/display-names');
  return data.names ?? [];
}

/** 이름 지정. 빈 문자열이면 원래 이름으로 되돌린다. */
export async function setDisplayName(
  kind: DisplayNameKind, targetId: string, name: string,
): Promise<string | null> {
  const { data } = await apiClient.put<{ name: string | null }>(
    `/chat/display-names/${kind}/${targetId}`, { name },
  );
  return data.name ?? null;
}

/** 원래 이름으로 되돌리기. */
export async function clearDisplayName(kind: DisplayNameKind, targetId: string): Promise<void> {
  await apiClient.delete(`/chat/display-names/${kind}/${targetId}`);
}
